import script from "./TheSddsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSddsHeader.vue?vue&type=script&setup=true&lang=js"

import "./TheSddsHeader.vue?vue&type=style&index=0&id=4e125624&scoped=true&lang=css"

import exportComponent from "/builds/izee/leadservice/lead-admin-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e125624"]])

export default __exports__